'use client';

import { useEffect } from 'react';
import Header from '@/components/Header/Header';
import NotFoundContent from '@/components/NotFoundContent/NotFoundContent';
import Footer from '@/components/Footer/Footer';
import { logError } from '@/utils/log';

/**
 * Reference: https://nextjs.org/docs/app/api-reference/file-conventions/error#global-errorjs
 */

const GlobalError = ({ error }: { error: Error & { digest: string } }) => {
  useEffect(() => {
    logError({ error });
  }, [error]);

  return (
    <html>
      <body className="antialiased">
        <main className="flex min-h-screen flex-col">
          <Header />
          <div className="flex-grow">
            <NotFoundContent statusCode={500} />
          </div>
          <Footer />
        </main>
      </body>
    </html>
  );
};

export default GlobalError;
